export default __webpack_public_path__ + "static/media/icon_right_align.4b25aab3.svg";